"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpacingXxxxs = exports.SpacingXxxs = exports.SpacingXxxl = exports.SpacingXxs = exports.SpacingXxl = exports.SpacingXs = exports.SpacingXl = exports.SpacingSm = exports.SpacingQuarck = exports.SpacingNano = exports.SpacingMd = exports.SpacingLg = exports.SpacingInsetXxs = exports.SpacingInsetXs = exports.SpacingInsetSm = exports.SpacingInsetQuarck = exports.SpacingInsetNano = exports.SpacingInsetMd = exports.SpacingInsetLg = exports.SpacingHuge = exports.SpacingGiant = exports.ShadowLevel4 = exports.ShadowLevel3 = exports.ShadowLevel2 = exports.ShadowLevel1 = exports.OpacityLevelSemitransparent = exports.OpacityLevelSemiopaque = exports.OpacityLevelRegular = exports.OpacityLevelMedium = exports.OpacityLevelLight = exports.OpacityLevelIntense = exports.LineHeightXxl = exports.LineHeightXs = exports.LineHeightXl = exports.LineHeightSm = exports.LineHeightMd = exports.LineHeightLg = exports.LineHeightDefault = exports.FontWeightSemiBold = exports.FontWeightRegular = exports.FontWeightLight = exports.FontWeightBold = exports.FontSizeXxxs = exports.FontSizeXxxl = exports.FontSizeXxs = exports.FontSizeXxl = exports.FontSizeXs = exports.FontSizeXl = exports.FontSizeSm = exports.FontSizeMd = exports.FontSizeLg = exports.FontSizeGiant = exports.FontSizeDisplay = exports.BorderWidthThin = exports.BorderWidthThick = exports.BorderWidthNone = exports.BorderWidthHeavy = exports.BorderWidthHairline = exports.BorderRadiusXs = exports.BorderRadiusSm = exports.BorderRadiusPill = exports.BorderRadiusNone = exports.BorderRadiusMd = exports.BorderRadiusLg = exports.BorderRadiusCircular = void 0;
/**
 * Do not edit directly
 * Generated on Fri, 11 Apr 2025 12:21:56 GMT
 */

var BorderRadiusNone = "0px";
exports.BorderRadiusNone = BorderRadiusNone;
var BorderRadiusXs = "4px";
exports.BorderRadiusXs = BorderRadiusXs;
var BorderRadiusSm = "8px";
exports.BorderRadiusSm = BorderRadiusSm;
var BorderRadiusMd = "16px";
exports.BorderRadiusMd = BorderRadiusMd;
var BorderRadiusLg = "24px";
exports.BorderRadiusLg = BorderRadiusLg;
var BorderRadiusPill = "500px";
exports.BorderRadiusPill = BorderRadiusPill;
var BorderRadiusCircular = "50%";
exports.BorderRadiusCircular = BorderRadiusCircular;
var BorderWidthNone = "0px";
exports.BorderWidthNone = BorderWidthNone;
var BorderWidthHairline = "1px";
exports.BorderWidthHairline = BorderWidthHairline;
var BorderWidthThin = "2px";
exports.BorderWidthThin = BorderWidthThin;
var BorderWidthThick = "4px";
exports.BorderWidthThick = BorderWidthThick;
var BorderWidthHeavy = "8px";
exports.BorderWidthHeavy = BorderWidthHeavy;
var FontSizeXxxs = "12px";
exports.FontSizeXxxs = FontSizeXxxs;
var FontSizeXxs = "14px";
exports.FontSizeXxs = FontSizeXxs;
var FontSizeXs = "16px";
exports.FontSizeXs = FontSizeXs;
var FontSizeSm = "20px";
exports.FontSizeSm = FontSizeSm;
var FontSizeMd = "24px";
exports.FontSizeMd = FontSizeMd;
var FontSizeLg = "32px";
exports.FontSizeLg = FontSizeLg;
var FontSizeXl = "40px";
exports.FontSizeXl = FontSizeXl;
var FontSizeXxl = "48px";
exports.FontSizeXxl = FontSizeXxl;
var FontSizeXxxl = "64px";
exports.FontSizeXxxl = FontSizeXxxl;
var FontSizeDisplay = "80px";
exports.FontSizeDisplay = FontSizeDisplay;
var FontSizeGiant = "98px";
exports.FontSizeGiant = FontSizeGiant;
var FontWeightLight = 300;
exports.FontWeightLight = FontWeightLight;
var FontWeightRegular = 400;
exports.FontWeightRegular = FontWeightRegular;
var FontWeightSemiBold = 600;
exports.FontWeightSemiBold = FontWeightSemiBold;
var FontWeightBold = 700;
exports.FontWeightBold = FontWeightBold;
var LineHeightDefault = "100%";
exports.LineHeightDefault = LineHeightDefault;
var LineHeightXs = "115%";
exports.LineHeightXs = LineHeightXs;
var LineHeightSm = "120%";
exports.LineHeightSm = LineHeightSm;
var LineHeightMd = "133%";
exports.LineHeightMd = LineHeightMd;
var LineHeightLg = "150%";
exports.LineHeightLg = LineHeightLg;
var LineHeightXl = "170%";
exports.LineHeightXl = LineHeightXl;
var LineHeightXxl = "200%";
exports.LineHeightXxl = LineHeightXxl;
var OpacityLevelSemiopaque = "72%";
exports.OpacityLevelSemiopaque = OpacityLevelSemiopaque;
var OpacityLevelIntense = "64%";
exports.OpacityLevelIntense = OpacityLevelIntense;
var OpacityLevelMedium = "32%";
exports.OpacityLevelMedium = OpacityLevelMedium;
var OpacityLevelRegular = "24%";
exports.OpacityLevelRegular = OpacityLevelRegular;
var OpacityLevelLight = "16%";
exports.OpacityLevelLight = OpacityLevelLight;
var OpacityLevelSemitransparent = "8%";
exports.OpacityLevelSemitransparent = OpacityLevelSemitransparent;
var ShadowLevel1 = "0px 4px 8px rgba(0, 0, 0, 0.08)";
exports.ShadowLevel1 = ShadowLevel1;
var ShadowLevel2 = "0px 8px 24px rgba(0, 0, 0, 0.16)";
exports.ShadowLevel2 = ShadowLevel2;
var ShadowLevel3 = "0px 16px 32px rgba(0, 0, 0, 0.16)";
exports.ShadowLevel3 = ShadowLevel3;
var ShadowLevel4 = "0px 16px 48px rgba(0, 0, 0, 0.24)";
exports.ShadowLevel4 = ShadowLevel4;
var SpacingInsetQuarck = "4px";
exports.SpacingInsetQuarck = SpacingInsetQuarck;
var SpacingInsetNano = "8px";
exports.SpacingInsetNano = SpacingInsetNano;
var SpacingInsetXxs = "12px";
exports.SpacingInsetXxs = SpacingInsetXxs;
var SpacingInsetXs = "16px";
exports.SpacingInsetXs = SpacingInsetXs;
var SpacingInsetSm = "24px";
exports.SpacingInsetSm = SpacingInsetSm;
var SpacingInsetMd = "32px";
exports.SpacingInsetMd = SpacingInsetMd;
var SpacingInsetLg = "40px";
exports.SpacingInsetLg = SpacingInsetLg;
var SpacingQuarck = "4px";
exports.SpacingQuarck = SpacingQuarck;
var SpacingNano = "8px";
exports.SpacingNano = SpacingNano;
var SpacingXxxxs = "12px";
exports.SpacingXxxxs = SpacingXxxxs;
var SpacingXxxs = "16px";
exports.SpacingXxxs = SpacingXxxs;
var SpacingXxs = "24px";
exports.SpacingXxs = SpacingXxs;
var SpacingXs = "32px";
exports.SpacingXs = SpacingXs;
var SpacingSm = "40px";
exports.SpacingSm = SpacingSm;
var SpacingMd = "48px";
exports.SpacingMd = SpacingMd;
var SpacingLg = "56px";
exports.SpacingLg = SpacingLg;
var SpacingXl = "64px";
exports.SpacingXl = SpacingXl;
var SpacingXxl = "80px";
exports.SpacingXxl = SpacingXxl;
var SpacingXxxl = "120px";
exports.SpacingXxxl = SpacingXxxl;
var SpacingHuge = "160px";
exports.SpacingHuge = SpacingHuge;
var SpacingGiant = "200px";
exports.SpacingGiant = SpacingGiant;